import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretDown = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M17.4573 29.7454C18.863 31.1511 21.1458 31.1511 22.5514 29.7454L36.9454 15.3514C37.98 14.3169 38.2836 12.7763 37.7214 11.4268C37.1591 10.0774 35.8546 9.20026 34.3928 9.20026L5.60476 9.20026C4.15412 9.20026 2.83841 10.0774 2.27615 11.4268C1.71388 12.7763 2.02875 14.3169 3.05207 15.3514L17.4461 29.7454H17.4573Z" })
});
export default SvgCaretDown;
